export default "__VITE_ASSET__0cc4aa39__"